import { useAppSelector } from "../../../../store/reduxHooks";
import { APPLICATION_BANK_STATUS_DEFAULT } from "../../../../utils/guards/ApplicationBankStatusGuard/types";

import { ExternalBankBaseInfo } from "./StatusState/BaseInfo";
import { ExternalBankUploadDocs } from "./StatusState/UploadDocs";
import { ExternalBankDisableUploadDocs } from "./StatusState/DisableUploadDocs";

export const ExternalBankContent = () => {
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );

  if (
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_DEFAULT.REJECTED ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_DEFAULT.REVISION ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_DEFAULT.DIRECTED
  ) {
    return <ExternalBankBaseInfo />;
  }

  if (
    activeBankInfo.status.type ===
      APPLICATION_BANK_STATUS_DEFAULT.REQUIRED_SIGNATURE ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_DEFAULT.ISSUED
  ) {
    return <ExternalBankDisableUploadDocs />;
  }

  return <ExternalBankUploadDocs />;
};
